import React from "react";
import SignupComp from "../components/signup/SignupComp";

const Signup = () => {
  return (
    <div>
      <SignupComp />
    </div>
  );
};

export default Signup;
